<template>
  <footer class="footer" v-bind:class="[footerNavbar ? 'footerNavbar' : '']">
    <div
      v-bind:class="[containerFluidHome ? 'containerFluidHome' : '']"
      class="container-fluid d-flex justify-content-between"
    >
      <div class="footer-copyright d-flex">
        <div class="mr-3">American Institute of Professional Studies</div>
        <div>2021 All Rights Reserved © AIPS</div>
      </div>
      <div class="footer-links">
        <router-link v-if="(header[5]) ? header[5].status : false"
                    to="/privacy" class="footer-link">Privacy Policy</router-link>
        <router-link v-if="(header[6]) ? header[6].status : false"
                    to="/events" class="footer-link">Events &amp; Conferences</router-link>
        <router-link v-if="(header[7]) ? header[7].status : false"
                    to="/online-trainings" class="footer-link">Online Training</router-link>

        <router-link v-for="(pg, idx) in pages" :key="idx"
                      :to="{ name: 'show-page', params:{slug: pg.slug}}" 
                class="footer-link"
                :class="(pg.has_footer) ? '' : 'hidden' ">
                {{ pg.title }}
        </router-link>

        <!-- <div v-for="(nav, index) in navbar" :key="index">
          <router-link
            v-if="nav.has_footer"
            :to="{ name: 'show-page', params: { slug: nav.slug }}"
            class="nav-link"
            :key="index"
          >{{ nav.title }}</router-link>
        </div>-->
      </div>
      <div class="footer-social">
        <div class="text">Follow Us</div>
         <a
          v-for="(social, index) in rows"
          class="social-icon"
          :href="social.provider_url"
          :key="index"
          target="_blank"
        >
          <i
            v-if="social.provider.toLowerCase() == 'facebook'"
            class="fab fa-facebook-f"
          ></i>
          <i
            v-if="social.provider.toLowerCase() == 'youtube'"
            class="fab fa-youtube"
          ></i>
          <i
            v-if="social.provider.toLowerCase() == 'linkedin'"
            class="fab fa-linkedin-in"
          ></i>
          <i
            v-if="social.provider.toLowerCase() == 'twitter'"
            class="fab fa-twitter"
          ></i>
        </a>
        
      </div>
    </div>
  </footer>
</template>

<style scoped>
  .hidden { display: none !important }
  .footer {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;
    align-items: center;
    line-height: 1;
  }
  .footer .text {
    color: #555555;
    font-size: 14px;
    margin-right: 13px;
    line-height: 1;
    font-weight: 600;
  }

  .footer-social {
    display: flex;
    align-items: center;
  }

  .social-icon {
    font-size: 13.5px;
    color: #555;
    margin-left: 13px;
    line-height: 1;
  }
  .social-icon:hover {
    color: #4f17a8;
  }
  .footer-link {
    color: #555555;
    font-size: 14px;
    margin-right: 30px;
    font-weight: 600;
  }
  .footer-link:hover {
    color: #4f17a8;
  }
  .footer-links {
    display: none;
  }
  .containerFluidHome {
    padding: 0;
  }
  .containerFluidHome .footer-copyright {
    display: none !important;
  }
  .containerFluidHome .footer-links {
    display: block !important;
  }
  .footerNavbar {
    padding: 13px 0;
  }
  .footerNavbar .container-fluid {
    padding: 0;
  }
  .footerNavbar .footer-copyright > div,
  .footerNavbar .text,
  .footerNavbar i {
    color: #999;
  }
  /* Extra small devices (portrait phones, less than 576px) */
  @media (max-width: 575.98px) {
  }

  @media (max-width: 767.98px) {
    .footer-copyright > div {
      font-size: 12px;
    }
    .footer-copyright > div:first-of-type {
      display: none;
    }
    .footer {
      padding: 13px 0;
    }
    .footer .text {
      font-size: 13px;
      margin-right: 2px;
    }
    .containerFluidHome .footer-copyright {
      display: block !important;
    }
    .containerFluidHome .footer-links {
      display: none !important;
    }
    .containerFluidHome div,
    .containerFluidHome a,
    .containerFluidHome i,
    .containerFluidHome .text {
      color: #848484;
    }
  }

  /* Small devices (landscape phones, 576px and up) */
  @media (min-width: 576px) and (max-width: 767.98px) {
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) and (max-width: 991.98px) {
  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) and (max-width: 1199.98px) {
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }
</style>

<script>
import axios from "axios";
export default {
  name: "Footer",
  components: {},
  data() {
    return {
      rows: [],
      pages: [],
      header: [],
    };
  },
  props: ["has_links", "containerFluidHome", "footerNavbar"],
  created() {

    axios
      .get(window.baseURL + "/setting")
      .then((res) => {
        this.rows = res.data.social;
        this.header = res.data.header;
      })
      .catch(() => { });


      axios
      .get(window.baseURL + "/pages")
      .then((res) => {
        var data = res.data.rows;
        this.pages = res.data.rows;
      })
      .catch(() => {});
  },
};
</script>
